import { apiClient } from '@/lib/api/client';
import type { BranchOffice, BranchOfficeListResponse } from '../types/branchOffice.types';

export const branchOfficeService = {
  async getBranchOffices(params?: {
    page?: number;
    pageSize?: number;
    search?: string;
    activeOnly?: boolean;
  }): Promise<BranchOfficeListResponse> {
    console.log('branchOfficeService.getBranchOffices - Called with params:', params);

    const queryParams = new URLSearchParams();
    if (params?.page) queryParams.append('page', params.page.toString());
    if (params?.pageSize) queryParams.append('pageSize', params.pageSize.toString());
    if (params?.search) queryParams.append('search', params.search);
    if (params?.activeOnly) queryParams.append('activeOnly', 'true');

    const url = `/companies/branch-offices?${queryParams.toString()}`;
    console.log('branchOfficeService.getBranchOffices - Calling URL:', url);

    const response = await apiClient.get(url);

    console.log('branchOfficeService.getBranchOffices - Response:', response.data);
    return response.data;
  },

  async getBranchOfficeById(id: string): Promise<BranchOffice> {
    const response = await apiClient.get(`/companies/branch-offices/${id}`);
    return response.data;
  },

  async createBranchOffice(branch: Partial<BranchOffice>): Promise<BranchOffice> {
    const response = await apiClient.post('/companies/branch-offices', branch);
    return response.data;
  },

  async updateBranchOffice(id: string, branch: Partial<BranchOffice>): Promise<BranchOffice> {
    const response = await apiClient.put(`/companies/branch-offices/${id}`, branch);
    return response.data;
  },

  async deleteBranchOffice(id: string, companyId: string): Promise<void> {
    // Instead of deleting, we deactivate the branch office by setting IsActive to false
    await apiClient.put(`/companies/branch-offices/${id}`, {
      BranchOfficeId: id,
      CompanyId: companyId,
      CountryId: null,
      IsActive: false,
    });
  },

  async reactivateBranchOffice(id: string, companyId: string): Promise<void> {
    await apiClient.put(`/companies/branch-offices/${id}`, {
      BranchOfficeId: id,
      CompanyId: companyId,
      CountryId: null,
      IsActive: true,
    });
  },

  /**
   * Obtiene los detalles completos de una sucursal desde Aludra API
   * Esto trae información adicional como Address_AddressDetail, Address_Latitude, Address_Longitude, Code, etc.
   */
  async getBranchOfficeDetailsFromAludra(companyId: string, branchOfficeId: string): Promise<any> {
    console.log('🔍 Obteniendo detalles de sucursal desde Aludra API:', { companyId, branchOfficeId });

    const response = await apiClient.post('/branchoffice/search', {
      CompanyId: companyId,
      BranchOfficeId: branchOfficeId,
      PageNumber: 1,
      PageSize: 10,
      IsActive: true
    });

    console.log('✅ RESPUESTA COMPLETA del API de Aludra:', JSON.stringify(response.data, null, 2));

    // El API retorna un array, tomamos el primer elemento
    const branchDetails = response.data?.Data?.[0] || response.data?.[0];

    if (!branchDetails) {
      console.error('❌ No se encontraron detalles de la sucursal');
      console.error('❌ response.data:', response.data);
      throw new Error('No se encontraron detalles de la sucursal');
    }

    console.log('🔍 OBJETO BRANCHDETAILS EXTRAÍDO:', JSON.stringify(branchDetails, null, 2));
    console.log('🔍 Campos importantes:');
    console.log('  - Code:', branchDetails.Code);
    console.log('  - Description:', branchDetails.Description);
    console.log('  - Address_AddressDetail:', branchDetails.Address_AddressDetail);
    console.log('  - Address_Latitude:', branchDetails.Address_Latitude);
    console.log('  - Address_Longitude:', branchDetails.Address_Longitude);
    console.log('  - Address_FiscalCode:', branchDetails.Address_FiscalCode);
    console.log('  - Address_ProvinceName:', branchDetails.Address_ProvinceName);
    console.log('  - Address_DistrictName:', branchDetails.Address_DistrictName);
    console.log('  - Address_TownshipName:', branchDetails.Address_TownshipName);

    return branchDetails;
  },
};
